import Joi from "joi";

import { numberOfNewParcels, totalWeightOfNewParcels } from "./commonSchema";

export default Joi.object({
  totalNewParcels: numberOfNewParcels(),
  totalWeightOfNewParcels,
});
